import { Recommendation } from "@/types";

export function getSavings(recommendations: Recommendation[]) {
  return recommendations.length !== 0
  ? Math.round(
      recommendations.reduce(
        (sum, rec) =>
          sum + (rec.info.saving !== undefined ? rec.info.saving : 0),
        0
      ) / recommendations.length
    )
  : 0;
}
export function getComfort(recommendations: Recommendation[]) {
  return recommendations.length !== 0
  ? Math.round(
      recommendations.reduce(
        (sum, rec) =>
          sum + (rec.info.comfort !== undefined ? rec.info.comfort : 0),
        0
      ) / recommendations.length
    )
  : 0;
}